module.exports = __webpack_public_path__ + "img/C03TechBrewing_ua.6c46a3d0.webp";